export default "__VITE_ASSET__CDNLtDDN__"